import { render, staticRenderFns } from "./Jview.vue?vue&type=template&id=c3cd3266"
import script from "./Jview.vue?vue&type=script&lang=js"
export * from "./Jview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports